import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Cannabis Fairfax · Your Trusted Source</p>
        <h1>Stay Informed on Cannabis Policy</h1>
        <p className="lede">
          At Cannabis Fairfax, we provide comprehensive coverage of local cannabis laws, policy updates, and cultural insights. Stay informed and engaged with the evolving landscape of cannabis in our community.
        </p>
        <div className="cta-row">
          <a href="/news" target="_self">
            Read the Latest News
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated on the latest changes in cannabis legislation and how they impact our community.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Access a wealth of information about cannabis, including its benefits, uses, and legal considerations.
          </p>
        </article>
        <article>
          <h2>Cultural Insights</h2>
          <p>
            Explore the cultural aspects of cannabis and how it shapes our community's identity and values.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;
